import { ArrowRight, ShieldCheck } from 'lucide-react';

type ReactivateSubscriptionPageProps = {
  tenantName?: string;
  productName?: string;
  monthlyPrice?: string;
  logoSrc?: string | null;
  onReactivate: () => void;
  isLoading?: boolean;
};

export function ReactivateSubscriptionPage({
  tenantName = 'Trade-Proof',
  productName = 'Trade-Proof',
  monthlyPrice = '$39',
  logoSrc,
  onReactivate,
  isLoading = false,
}: ReactivateSubscriptionPageProps) {
  return (
    <div className="min-h-screen bg-[#0B101E] text-slate-200 font-sans p-4 md:p-8 flex items-center justify-center">
      <div className="w-full max-w-4xl flex flex-col items-center space-y-12 py-10">
        <div className="text-center space-y-4 px-4">
          <div className="flex items-center justify-center mb-8">
            {logoSrc ? (
              <img
                src={logoSrc}
                alt={tenantName}
                className="h-16 md:h-20 w-auto object-contain drop-shadow-lg"
              />
            ) : (
              <div className="text-blue-400 text-xl font-bold tracking-[0.24em] uppercase">
                {tenantName}
              </div>
            )}
          </div>

          <h1 className="text-3xl md:text-3xl font-semibold text-white tracking-tight leading-snug">
            Reactivate your subscription
          </h1>
          <p className="text-md md:text-md text-slate-400">
            Restart your subscription to continue using your account.
          </p>
        </div>

        <div className="max-w-lg w-full space-y-6">
          <div className="w-full">
            <div>
              <div className="text-center mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
                  {productName}
                </h2>
                <div className="flex items-baseline justify-center gap-1 mb-4">
                  <span className="text-5xl font-black text-white">{monthlyPrice}</span>
                  <span className="text-slate-500 font-medium">/month</span>
                </div>
              </div>

              <div className="space-y-4">
                <button
                  type="button"
                  onClick={onReactivate}
                  disabled={isLoading}
                  className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold py-4 px-6 rounded-xl transition-all shadow-lg shadow-blue-900/20 flex items-center justify-center group"
                >
                  {isLoading ? 'Opening checkout…' : 'Reactivate Subscription'}
                  {!isLoading && (
                    <ArrowRight
                      size={20}
                      className="ml-2 group-hover:translate-x-1 transition-transform"
                    />
                  )}
                </button>

                <p className="text-center text-xs md:text-sm text-slate-500">
                  You'll be taken to secure checkout to restart your subscription.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center text-slate-500 text-xs space-x-2">
            <ShieldCheck size={14} className="text-slate-600" />
            <span>Secure, encrypted checkout</span>
          </div>
        </div>
      </div>
    </div>
  );
}
